import type { DragData } from '../../domain/dnd/types';

let dragItem: DragData | null = null;
const listeners = new Set<() => void>();

export function getEditorDragItemSnapshot(): DragData | null {
  return dragItem;
}

export function subscribeEditorDragItem(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function publishEditorDragItem(next: DragData | null): void {
  if (Object.is(dragItem, next)) {
    return;
  }
  dragItem = next;
  listeners.forEach(listener => {
    listener();
  });
}
